const OfficialAddress = [
  {
    id: "",
    gpText: "",
    osText: "",
  },
  {
    id: "C",
    gpText: "Postal Address confirmed and ready for notification",
    osText: undefined,
  },
  {
    id: "N",
    gpText: "Unofficial Address",
    osText: "LPI not generated through street naming and numbering",
  },
  {
    id: "R",
    gpText: "Postcode and post town requested from the Royal Mail",
    osText: undefined,
  },
  {
    id: "Y",
    gpText: "Official Address",
    osText: "LPI generated through street naming and numbering",
  },
];

export default OfficialAddress;
